import React, { Component } from 'react';
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
momentDurationFormatSetup(moment);

class Timer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            timeLeft: this.timeLeft()
        }

        this.timeLeft = this.timeLeft.bind(this);
    }

    onNext() {
        this.props.nextStep(this.state.answer);
    }

    timeLeft() {
        const { endTime } = this.props;
        let diffTime = moment(endTime).diff(moment());

        if (diffTime < 0) {
            this.props.submitTest();
        }
        const time = moment.duration(diffTime, 'milliseconds');
        return time.format("hh:mm:ss", { trim: false });
    }

    componentDidMount() {
        this.interval = setInterval(
            () => this.setState({ timeLeft: this.timeLeft() }),
            1000
        );
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        const { timeLeft } = this.state;

        return (
            <strong>{timeLeft}</strong>
        )
    }
};

export default Timer;



// WEBPACK FOOTER //
// ./src/components/LanguageTest/Timer.js